<template>
  <el-dialog
    :visible.sync="visible"
    :before-close="handleClose"
    :auto-close="true"
    title="组合铺货"
  >
    <slot name="title"></slot>
    <el-progress :text-inside="true" :stroke-width="20" :percentage="percentage"></el-progress>
  </el-dialog>
</template>

<script>
export default {
  props: {
    percentage: {
      type: [String, Number],
      default: 0
    }
  },
  data() {
    return {
      visible: false,
    }
  },
  methods: {
    showDialog() {
      this.visible = true
    },
    handleClose() {
      this.visible = false
    }
  }
}
</script>

<style>

</style>